import {
    useEffect, useMemo
} from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorShowPromoVideoModal } from '../../../../configuration/configuration.selectors';
import { useLocalStorage } from '../../../../hooks';
import {
    useSelectorUserProfiles, useSelectorIsTeacherUser
} from '../../../../user-profiles';
import { openModal } from '../../modal-manager/';
import { ModalVariants } from '../../modals';

export const useShowPromoVideoModal = ({
    classroomsYearGroups,
    validYearGroups,
    isValidCountryCode
}: {
    classroomsYearGroups?: number[]
    validYearGroups: number[]
    isValidCountryCode: boolean
}) => {
    const showPromoVideoModal = useSelectorShowPromoVideoModal();
    const { data: userProfilesData } = useSelectorUserProfiles();
    const isValidYearGroup = useMemo(() =>
        classroomsYearGroups?.some((year) => validYearGroups.includes(year))
    , [classroomsYearGroups, validYearGroups]);
    const isTeacher = useSelectorIsTeacherUser();
    const {
        getItem,
        setItem
    } = useLocalStorage();
    const dispatch = useDispatch();

    useEffect(() => {
        const userProfileId = userProfilesData?.user?.userProfileId;
        const showModalForUser = isTeacher ? (isValidCountryCode && isValidYearGroup) : isValidCountryCode;

        if (showPromoVideoModal && userProfileId && showModalForUser) {
            const hasSeenNewCoursesPromoVideoUserIds = getItem('hasSeenNewCoursesPromoVideoUserIds') || [];

            if (hasSeenNewCoursesPromoVideoUserIds.includes(userProfileId)) return;
            const updatedUserProfileIds = [...hasSeenNewCoursesPromoVideoUserIds, userProfileId];

            dispatch(openModal({ variant: ModalVariants.introducingNewCoursesModal }));
            setItem({
                key: 'hasSeenNewCoursesPromoVideoUserIds',
                value: updatedUserProfileIds
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getItem, setItem, userProfilesData, showPromoVideoModal]);
};
